import { useParams } from 'react-router-dom';
import React, { useState } from 'react';
import { useFormik } from 'formik';
import { Button, Input } from 'edozvola-frontend-lib/dist/ui/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { caseUuidToCopyFromSchema } from 'app/edozvola/cases/construction-participants/model/construction-participants.schema';
import SiteConstructorTable from 'app/edozvola/cases/construction-participants/site-constructor/site-constructor-table';
import SiteConstructorForm from 'app/edozvola/cases/construction-participants/site-constructor/site-constructor-form';
import { copySiteConstructorsFromCaseQuery } from 'app/edozvola/cases/construction-participants/service/construction-participants.queries';
import { getCaseContext } from 'app/shared/util/context-util';

const SiteConstructor = () => {
  const { id: uuid } = useParams<{ id: string }>();
  const [idSiteConstructor, setIdSiteConstructor] = useState<string | null>(null);
  const [readOnly, setReadOnly] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const copySiteConstructorFormik = useFormik({
    initialValues: { caseUuidToCopyFrom: '' },
    validationSchema: caseUuidToCopyFromSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: values => copySiteConstructor(values.caseUuidToCopyFrom),
  });

  const { mutate: copySiteConstructor, isPending: isCopySiteConstructorPending } = copySiteConstructorsFromCaseQuery(
    uuid,
    copySiteConstructorFormik.resetForm,
  );

  const openNewSiteConstructorForm = () => {
    setIdSiteConstructor('');
    setReadOnly(false);
  };

  return (
    <>
      <div className={'form-header'}>Izvođači radova</div>
      {!sidebarItemPair?.readOnly && (
        <>
          <div className={'d-flex justify-content-end pb-4 gap-2'}>
            <div className={'case-copy-from-other-case'}>
              <Input
                placeholder={'Unesite šifru predmeta'}
                maxLength={255}
                addonAppend={
                  isCopySiteConstructorPending ? (
                    <FontAwesomeIcon icon="spinner" spin />
                  ) : (
                    <FontAwesomeIcon
                      aria-disabled={
                        (!!copySiteConstructorFormik.errors && !!copySiteConstructorFormik.errors.caseUuidToCopyFrom) ||
                        copySiteConstructorFormik.values.caseUuidToCopyFrom === ''
                      }
                      className={
                        (!!copySiteConstructorFormik.errors && !!copySiteConstructorFormik.errors.caseUuidToCopyFrom) ||
                        copySiteConstructorFormik.values.caseUuidToCopyFrom === ''
                          ? 'disabled'
                          : ''
                      }
                      icon="copy"
                    />
                  )
                }
                value={copySiteConstructorFormik.values.caseUuidToCopyFrom}
                onChange={event => {
                  copySiteConstructorFormik.setFieldValue('caseUuidToCopyFrom', event.target.value);

                  if (copySiteConstructorFormik.submitCount > 0) {
                    copySiteConstructorFormik.setErrors({});
                  }
                }}
                addonAppendClick={() => {
                  if (!isCopySiteConstructorPending) {
                    copySiteConstructorFormik.handleSubmit();
                  }
                }}
                error={
                  copySiteConstructorFormik.errors && copySiteConstructorFormik.errors.caseUuidToCopyFrom
                    ? copySiteConstructorFormik.errors.caseUuidToCopyFrom
                    : ''
                }
              />
            </div>
            <div>
              <Button label={'Dodaj izvođača'} color={'info'} prependIcon={'plus'} size={'lg'} onClick={openNewSiteConstructorForm} />
            </div>
          </div>
        </>
      )}
      <>
        <SiteConstructorTable setSiteConstructor={setIdSiteConstructor} setReadOnly={setReadOnly} />
        {idSiteConstructor !== null && (
          <SiteConstructorForm idSiteConstructor={idSiteConstructor} setIdSiteConstructor={setIdSiteConstructor} readOnly={readOnly} />
        )}
      </>
    </>
  );
};

export default SiteConstructor;
